import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import './FloatingContactUs.css';

const FloatingContactUs = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (isMobile) return null;

  return (
    <div className="floating-contact-wrapper">
      {/* Laser Flow Vertical Contact Button */}
      <NavLink
        to="/contact#contactusform"
        className="floating-contact-pill laser-flow"
      >
        Contact Us
      </NavLink>

      {/* Social Icons */}
      <div className="floating-contact-icons">
        <a
          href="https://www.linkedin.com/company/nextech-plm-solutions/"
          target="_blank"
          rel="noopener noreferrer"
          className="floating-contact-icon"
        >
          <i className="fab fa-linkedin-in"></i>
        </a>

        <a
          href="https://wa.me/9226536772"
          target="_blank"
          rel="noopener noreferrer"
          className="floating-contact-icon"
        >
          <i className="fab fa-whatsapp"></i>
        </a>

        <a
          href="https://www.facebook.com/share/vNf8TQB9UWD12RVY/?mibextid=qi2Omg"
          target="_blank"
          rel="noopener noreferrer"
          className="floating-contact-icon"
        >
          <i className="fab fa-facebook-f"></i>
        </a>

        <a
          href="https://www.instagram.com/nextech_plm_solutions?igsh=MTUwOWtvM3h2cHJrdw=="
          target="_blank"
          rel="noopener noreferrer"
          className="floating-contact-icon"
        >
          <i className="fab fa-instagram"></i>
        </a>
      </div>
    </div>
  );
};

export default FloatingContactUs;
